module.exports = __webpack_public_path__ + "img/app_store_en.ec834885.png";